module.exports = ReactIntl;


//////////////////
// WEBPACK FOOTER
// external "ReactIntl"
// module id = 8
// module chunks = 0